/* unplugin-vue-components disabled */import { ElConfigProvider as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/config-provider/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import zhLocale from "element-plus/lib/locale/lang/zh-cn";
import indexApi from "@/api/index/index";
import { initRouter } from "@/router";
export default /*#__PURE__*/_defineComponent({
  __name: 'App',

  setup(__props) {
    const store = useStore();
    const locale = zhLocale; // 加载路由

    const routerList = computed(() => store.state.router.routerList); // 监听路由变化

    watch(routerList, () => {
      // 初始化路由
      initRouter(routerList);
    });
    onBeforeMount(() => {
      if (sessionStorage.getItem("token")) {
        initStore();
      }
    });
    onMounted(() => {
      // 初始化公钥
      indexApi.getPublicKey().then(res => {
        store.commit("setPublicKey", res.data);
      }); // 添加刷新事件-关闭时(刷新、返回)执行

      window.addEventListener("beforeunload", () => saveStore());
    });
    onUnmounted(() => {
      // 卸载刷新事件
      window.removeEventListener("beforeunload", () => saveStore());
    });

    const saveStore = () => {
      // 缓存token
      sessionStorage.setItem("token", store.state.auth.token); // 缓存account

      sessionStorage.setItem("account", JSON.stringify(store.state.auth.account)); // 缓存enterprise

      sessionStorage.setItem("enterprise", JSON.stringify(store.state.enterprise)); // 缓存menuList

      sessionStorage.setItem("menuList", JSON.stringify(store.state.menu.menuList)); // 缓存defaultActive

      sessionStorage.setItem("defaultActive", JSON.stringify(store.state.menu.defaultActive)); // 缓存router

      sessionStorage.setItem("routerList", JSON.stringify(store.state.router.routerList)); // 缓存router历史

      sessionStorage.setItem("routerHistory", JSON.stringify(store.state.router.routerHistory));
    }; // 初始化缓存-刷新


    const initStore = () => {
      // 设置token
      store.commit("setToken", sessionStorage.getItem("token")); // 设置account

      store.commit("setAccount", JSON.parse(sessionStorage.getItem("account")?.toString() || "")); // 设置merchant

      store.commit("setEnterprise", JSON.parse(sessionStorage.getItem("enterprise")?.toString() || "")); // 设置menuList

      store.commit("setMenuList", JSON.parse(sessionStorage.getItem("menuList")?.toString() || "")); // 设置defaultActive

      store.commit("setDefaultActive", JSON.parse(sessionStorage.getItem("defaultActive")?.toString() || "")); // 设置router

      store.commit("setRouterList", JSON.parse(sessionStorage.getItem("routerList")?.toString() || "")); // 初始化routerHistory

      store.commit("initRouterHistory", JSON.parse(sessionStorage.getItem("routerHistory")?.toString() || "")); // 清除信息

      sessionStorage.clear();
    };

    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");

      const _component_el_config_provider = __unplugin_components_0;

      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(locale)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, null, {
          default: _withCtx(({
            Component
          }) => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024))]),
          _: 1
        })]),
        _: 1
      }, 8, ["locale"]);
    };
  }

});